import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "../CustomInput";
import CustomPasswordInput from "../CustomPasswordInput";
import { Button } from "react-bootstrap";
import { useRegisterUser } from "../../../hooks/authV2/useRegisterUser";
import { useNavigate } from "react-router-dom";
import {
  firstNameSchema,
  lastNameSchema,
  emailSchema,
  passwordSchema,
  confirmPasswordSchema,
} from "../../../utils/validationSchemas";
import useHandleSuccess from "../../../utils/parent/useHandleSuccess";

export const AuthRegisterEmail = ({ setView, onHide }) => {
  const { registerUser, loading: registerLoading, error } = useRegisterUser();
  const { handleSuccess } = useHandleSuccess();
  const navigate = useNavigate();
  const [registered, setRegistered] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object().shape({
    firstName: firstNameSchema,
    lastName: lastNameSchema,
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: confirmPasswordSchema,
  });

  const handleSuccessFun = async (data) => {
    await handleSuccess({
      data,
      redirect: "",
      tab: "",
      navigate,
      navigation: false,
    });
  };

  const handleSubmit = (values, { resetForm }) => {
    registerUser(
      {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
      },
      async (data) => {
        await handleSuccessFun(data);
        resetForm();
        setRegisteredEmail(values.email);
        setRegistered(true);
      },
    );
  };

  const handleContinue = () => {
    onHide();
    navigate("/student/start-your-quest");
  };

  return (
    <>
      {registered ? (
        <>
          <div
            style={{ fontSize: "3rem", color: "#4ade80", marginBottom: "8px" }}
          >
            <i className="fa fa-check-circle" />
          </div>

          <div className="auth-modal-title" style={{ marginBottom: "16px" }}>
            Account Created Successfully!
          </div>

          <p className="auth-forgot__subtitle">
            Welcome to Yuva Quest! Your account has been created and you can
            start exploring the platform right away.
          </p>

          <div
            className="auth-verify-msg auth-verify-msg--success"
            style={{ textAlign: "left" }}
          >
            <strong>📧 Verify your email</strong>
            <br />
            We've sent a verification email to{" "}
            <strong>{registeredEmail}</strong>. Please verify within{" "}
            <strong>48 hours</strong> to continue using your account.
          </div>

          <Button
            className="custom-primary-button mt-3"
            onClick={handleContinue}
          >
            Continue to Explore →
          </Button>
        </>
      ) : (
        <>
          <div className="auth-modal-title">Create your account</div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {() => (
              <Form>
                <div className="auth-name-row">
                  <div className="auth-name-row__col">
                    <div className="auth-form-group">
                      <CustomInput
                        label="First Name"
                        name="firstName"
                        type="text"
                        placeholder="Enter your first name"
                        showAstreisk={false}
                      />
                    </div>
                  </div>
                  <div className="auth-name-row__col">
                    <div className="auth-form-group">
                      <CustomInput
                        label="Last Name"
                        name="lastName"
                        type="text"
                        placeholder="Enter your last name"
                        showAstreisk={false}
                      />
                    </div>
                  </div>
                </div>

                <div className="auth-form-group">
                  <CustomInput
                    label="Email"
                    name="email"
                    type="text"
                    placeholder="Enter your email"
                    showAstreisk={false}
                  />
                </div>

                <div className="auth-form-group">
                  <CustomPasswordInput
                    label="Password"
                    name="password"
                    placeholder="Enter your password"
                    showAstreisk={false}
                  />
                </div>

                <div className="auth-form-group">
                  <CustomPasswordInput
                    label="Confirm Password"
                    name="confirmPassword"
                    placeholder="Enter your password"
                    showAstreisk={false}
                  />
                </div>

                {error && (
                  <div className="text-danger text-center mb-3">{error}</div>
                )}

                <Button
                  type="submit"
                  className="custom-primary-button mt-2"
                  disabled={registerLoading}
                >
                  {registerLoading ? "Signing up..." : "Sign Up"}
                </Button>

                <div
                  className="text-center mt-3"
                  style={{ fontSize: "0.85rem", color: "#3a3a3a" }}
                >
                  By signing up, you agree to our{" "}
                  <a
                    href="/terms"
                    target="_blank"
                    rel="noreferrer"
                    className="authLink"
                  >
                    Terms & Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    href="/privacy"
                    target="_blank"
                    rel="noreferrer"
                    className="authLink"
                  >
                    Privacy Policy
                  </a>
                  .
                </div>

                <div
                  className="text-center mt-3"
                  style={{ fontSize: "0.95rem", color: "#3a3a3a" }}
                >
                  Already have an account?{" "}
                  <span onClick={() => setView("login")} className="authLink">
                    Sign In
                  </span>
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};
